import { render, staticRenderFns } from "./GSchoolClassChangeConfirmModal.vue?vue&type=template&id=4722463d&scoped=true&"
import script from "./GSchoolClassChangeConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./GSchoolClassChangeConfirmModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4722463d",
  null
  
)

export default component.exports